var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9CA9BD",
    fillRule: "nonzero",
    d: "M8.148 0A8.15 8.15 0 0 0 0 8.148c0 5.359 5.298 7.924 5.961 8.52.678.61 1.238 1.977 1.464 2.752.11.376.418.567.723.575a.77.77 0 0 0 .723-.575c.226-.775.786-2.14 1.464-2.751.664-.597 5.961-3.162 5.961-8.52 0-4.5-3.648-8.149-8.148-8.149m0 10.37a2.222 2.222 0 1 1 0-4.444 2.222 2.222 0 0 1 0 4.444"
  })));
};
export default SvgLocation;